import { Component, Input } from '@angular/core';
import { PolicyDto } from '../../../../../service/dto-insurance';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DependantDto, DynamicFormDto } from '../../../../../service/dto';
import { FormResult } from '../../../../../components/dynamic-form/dynamic-form.component';
import { HttpDependantService } from '../../../../../service/http-dependant.service';
import { switchMap } from 'rxjs';

@Component({
	selector: 'app-policy-add-dependant-modal',
	standalone: false,
	templateUrl: './policy-add-dependant-modal.component.html',
	styleUrl: './policy-add-dependant-modal.component.scss'
})
export class PolicyAddDependantModalComponent {
	@Input() policy!: PolicyDto;
	@Input() dependant?: DependantDto;
	data?: DynamicFormDto;

	constructor(private modalRef: NzModalRef, private httpService: HttpDependantService) {
		this.policy = this.modalRef.getConfig().nzData.policy;
		this.dependant = this.modalRef.getConfig().nzData.dependant;
	}

	ngOnInit() {
		if (this.dependant) {
			this.httpService.get(+this.dependant.id).subscribe(result => {
				this.data = result;
			});
		} else {
			this.httpService.getForm().subscribe(result => {
				this.data = result;
			});
		}
	}


	doHandleResult(input: FormResult) {
		if (input.type == 'Cancel') {
			this.modalRef.close(null);
			return;
		}
		if (this.dependant) {
			this.httpService.edit(this.dependant.id, input.data)
				.pipe(switchMap(result => this.httpService.getEntity(result.id!)))
				.subscribe(result => {
					this.modalRef.close(result);
				});
		} else {
			this.httpService.createForPolicy(this.policy, input.data)
				.pipe(switchMap(result => this.httpService.getEntity(result.id!)))
				.subscribe(result => {
					this.modalRef.close(result);
				});
		}
	}
	remove() {
		this.modalRef.close(undefined);
	}
	cancel() {
		this.modalRef.close(undefined);
	}
}
